import { environment } from '../../../../environments/environment';

// Validate company tax id number availability
export function CompanyTaxIdNumberAvailableValidatorDirective($q, $http) {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      ngModel.$asyncValidators.companyTaxIdNumberAvailable = function (modelValue) {
        if (modelValue !== attrs.companyTaxIdNumberAvailableValidator) {
          return $http.get(
            environment.apiEndpoint + 'sessions/check_company_tax_id_number?q=' + modelValue
          );
        }

        return $q.resolve(true);
      };
    },
  };
}

CompanyTaxIdNumberAvailableValidatorDirective.$inject = ['$q', '$http'];
